import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'RDCost系统如何确保数据安全？',
      answer: '我们采用银行级别的数据加密技术，所有数据传输使用SSL加密，数据存储采用多重备份机制。同时，我们通过了ISO27001信息安全管理体系认证，并定期进行安全审计，确保您的研发数据绝对安全。',
      icon: 'ri-shield-check-line',
      color: 'text-teal-600'
    },
    {
      question: '系统部署需要多长时间？',
      answer: '标准版本通常在3-5个工作日内即可完成部署和初始化配置。如果需要与现有系统集成或定制化开发，时间会根据具体需求而定，一般在2-4周内完成。我们提供专业的实施团队全程协助，确保系统顺利上线。',
      icon: 'ri-time-line',
      color: 'text-blue-600'
    },
    {
      question: '是否支持与现有财务系统对接？',
      answer: '是的，RDCost支持与主流财务系统（如用友、金蝶、SAP等）、人力资源系统、项目管理系统进行数据对接。我们提供标准API接口和定制化对接服务，实现数据自动同步，无需重复录入。',
      icon: 'ri-links-line',
      color: 'text-purple-600'
    },
    {
      question: '研发费用加计扣除政策经常变化，系统如何应对？',
      answer: '我们有专门的政策研究团队，持续跟踪国家和地方的研发费用相关政策变化。一旦政策更新，系统会在第一时间进行升级调整，并通过系统消息和邮件通知所有用户。所有政策更新都是免费的。',
      icon: 'ri-refresh-line',
      color: 'text-green-600'
    },
    {
      question: '如果遇到问题，能得到什么样的技术支持？',
      answer: '我们提供多层次的技术支持服务：基础版用户享有邮件支持（24小时内响应），专业版用户享有电话+邮件支持（4小时内响应），企业版用户享有专属客户经理和7×24小时紧急支持。此外，我们还提供详细的在线帮助文档和视频教程。',
      icon: 'ri-customer-service-line',
      color: 'text-orange-600'
    },
    {
      question: '系统是否支持多地研发中心的费用管理？',
      answer: '完全支持。RDCost采用多组织架构设计，可以灵活设置总部、分公司、研发中心等多级组织结构，每个组织可以独立管理自己的研发项目和费用，同时总部可以查看和汇总所有组织的数据，实现集团化管理。',
      icon: 'ri-building-line',
      color: 'text-red-600'
    },
    {
      question: '试用期结束后，数据会丢失吗？',
      answer: '不会。试用期结束后，如果您选择购买正式版本，所有试用期间的数据都会完整保留并自动迁移到正式环境。即使您暂时不购买，我们也会为您保留数据30天，方便您随时恢复使用。',
      icon: 'ri-database-2-line',
      color: 'text-indigo-600'
    },
    {
      question: '系统能否生成符合税务要求的审计报告？',
      answer: '可以。RDCost内置了符合国家税务总局要求的各类报表模板，包括研发费用辅助账、加计扣除明细表、高新技术企业认定报表等。系统生成的报告完全符合税务审计要求，并且支持导出为Excel、PDF等多种格式。',
      icon: 'ri-file-chart-line',
      color: 'text-pink-600'
    }
  ];

  return (
    <section id="faq" className="py-16 lg:py-20 bg-gradient-to-b from-white via-gray-50 to-white relative overflow-hidden">
      {/* 装饰性背景 */}
      <div className="absolute top-20 right-20 w-80 h-80 bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse"></div>
      <div className="absolute bottom-20 left-20 w-80 h-80 bg-teal-100 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse" style={{ animationDelay: '2s' }}></div>

      <div className="max-w-4xl mx-auto px-6 lg:px-12 relative z-10">
        <div className="text-center mb-14">
          <div className="inline-flex items-center bg-gradient-to-r from-teal-50 to-blue-50 text-teal-700 px-5 py-2.5 rounded-full text-sm font-semibold mb-5 border border-teal-100 shadow-sm">
            <i className="ri-question-line mr-2"></i>
            常见问题
          </div>
          <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-5">
            您可能想了解的
            <span className="block mt-2 bg-gradient-to-r from-teal-600 to-blue-600 bg-clip-text text-transparent">
              问题解答
            </span>
          </h3>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            我们整理了用户最关心的问题，如果您还有其他疑问，欢迎随时联系我们
          </p>
        </div>

        <div className="space-y-4 mb-16">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className={`border-2 rounded-2xl overflow-hidden transition-all duration-300 ${
                openIndex === index 
                  ? 'border-teal-300 shadow-lg' 
                  : 'border-gray-200 hover:border-teal-200 shadow-sm'
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left bg-white hover:bg-gradient-to-r hover:from-teal-50/50 hover:to-blue-50/50 transition-all cursor-pointer group"
              >
                <div className="flex items-center flex-1 pr-4">
                  <div className={`w-12 h-12 flex items-center justify-center bg-gradient-to-br from-teal-50 to-blue-50 rounded-xl mr-5 flex-shrink-0 group-hover:scale-110 transition-transform`}>
                    <i className={`${faq.icon} text-2xl ${faq.color}`}></i>
                  </div>
                  <h4 className="text-lg font-bold text-gray-900">
                    {faq.question}
                  </h4>
                </div>
                <div className={`w-10 h-10 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0 transition-all ${openIndex === index ? 'rotate-180 bg-teal-600' : 'group-hover:bg-teal-200'}`}>
                  <i className={`ri-arrow-down-s-line text-2xl transition-colors ${openIndex === index ? 'text-white' : 'text-teal-600'}`}></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-8 pb-6 bg-gradient-to-r from-gray-50/50 to-blue-50/30">
                  <div className="pl-16">
                    <p className="text-gray-700 leading-relaxed text-base">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* 移除了"还有其他问题"咨询区块 */}
      </div>
    </section>
  );
}
